import { useState } from "react";
import { EMarketTypes } from "../../../../../../interfaces";
import AboutFacilityFrom from "../../../../../shared/forms/aboutFacilityForm";
import Button from "../../../../../ui/button";
import { ComplexAnimatedModal } from "../../../../../ui/modal/ComplexAnimatedModal";
import { IDataModal } from "../../../../estimate";
import styles from "./styles.module.scss";
import useDealRequestExchange, {
  EDealRequestLinkType,
} from "../../../../../../api/hooks/use-deal-request-exchange";
import { getAccessToken } from "../../../../../../lib/services/localStorage.service";
import { toast } from "react-toastify";
import AuthModal from "../../../../auth/components/modals/authModal";
import useOpenModal from "../../../../../ui/modal/hooks/useOpenModal";

interface TradeInModal {
  id: number;
  opened: boolean;
  marketType: EMarketTypes;
  onClose: (value: boolean) => void;
  offsetY: number;
}

interface IDataTradedIn extends Partial<IDataModal> {}

const FacilityCardTradeInModal = ({
  id: facilityId,
  opened,
  onClose,
  marketType,
  offsetY,
}: TradeInModal) => {
  const {
    offsetY: offsetYAuth,
    open: openAuth,
    handleChangeModal: handleChangeModalAuth,
  } = useOpenModal();

  const [dataTradeIn, setDataTradeIn] = useState<IDataTradedIn>();

  const isDisabled =
    !!dataTradeIn?.streetId &&
    !!dataTradeIn?.areaInSqM &&
    !!dataTradeIn?.apartmentNumber &&
    !!dataTradeIn?.buildingId;

  const handleChange = (data: Partial<IDataModal> | null) => {
    setDataTradeIn(data as IDataTradedIn);
  };

  const { trigger, isMutating: isMutatingTradeIn } = useDealRequestExchange();

  const handleTradeIn = async () => {
    const isAllSelected = !!isDisabled;

    if (getAccessToken()) {
      try {
        if (isAllSelected) {
          await trigger({
            data: {
              streetId: dataTradeIn?.streetId,
              apartmentNumber: dataTradeIn?.apartmentNumber,
              areaInSqM: Number(dataTradeIn?.areaInSqM),
              buildingId: dataTradeIn?.buildingId,
              facilityId: facilityId,
            },
            marketType: marketType,
            type: EDealRequestLinkType.TradeIn,
          });
        }

        toast.success(
          "Ваша заявка принята, наш эксперт свяжется с вами в течении 2х часов в рабочее время."
        );
        onClose(false);
      } catch (error: any) {
        if (error.message === "Unauthorized") {
          handleChangeModalAuth(true);
        }
      }
    } else {
      handleChangeModalAuth(true);
    }
  };

  return (
    <div>
      {openAuth && (
        <AuthModal
          opened={openAuth}
          onClose={() => handleChangeModalAuth(false)}
          offsetY={offsetYAuth}
        />
      )}
      <ComplexAnimatedModal
        opened={opened}
        onClose={() => onClose(false)}
        offsetY={offsetY}
      >
        <div className={styles.tradeInModal}>
          <div className={styles.tradeInModal__container}>
            <div className={styles.tradeInModal__title}>Заявка на ТРЕЙД-ИН</div>
            <div className={styles.tradeInModal__text}>
              Чтобы отправить заявку заполните данные вашей старой квартиры.
            </div>
            <AboutFacilityFrom
              onChange={handleChange}
              marketType={EMarketTypes.SECONDARY}
            />
            <div className={styles.tradeInModal__button}>
              <Button
                disabled={!isDisabled}
                label="Отправить заявку на ТРЕЙД-ИН"
                onClick={handleTradeIn}
                loading={isMutatingTradeIn}
              />
            </div>
          </div>
        </div>
      </ComplexAnimatedModal>
    </div>
  );
};

export default FacilityCardTradeInModal;
